var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterSupply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4_258)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 50,
    r: 50,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.0997 65.3313C70.1164 69.8785 61.9178 72.3416 53.5 72.3416C45.0822 72.3416 36.8809 69.8785 29.8976 65.3313L26 69.2289C34.0659 74.7506 43.6747 77.755 53.5 77.755C63.3253 77.755 72.9341 74.7506 81 69.2289L77.0997 65.3313Z",
    fill: "#8FB16A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9357 66.9284C62.8922 66.9284 70.1759 59.6447 70.1759 50.6882C70.1759 42.4978 57.4923 26.439 56.0469 24.6363L53.9357 22L51.8245 24.6363C50.3764 26.439 37.6956 42.4978 37.6956 50.6882C37.6956 59.6447 44.9793 66.9284 53.9357 66.9284ZM53.9357 30.7534C58.7861 37.2279 64.7625 46.5632 64.7625 50.6882C64.7625 56.6592 59.9067 61.515 53.9357 61.515C47.9647 61.515 43.1089 56.6592 43.1089 50.6882C43.1089 46.5687 49.0853 37.2306 53.9357 30.7534Z",
    fill: "#8FB16A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3798 50.6884H57.3198C57.3198 52.556 55.8013 54.0717 53.9364 54.0717V58.1318C55.9099 58.1296 57.8019 57.3447 59.1973 55.9493C60.5928 54.5538 61.3777 52.6618 61.3798 50.6884Z",
    fill: "#8FB16A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4_258",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.560784 0 0 0 0 0.694118 0 0 0 0 0.415686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_258"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_258",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterSupply);
export default __webpack_public_path__ + "static/media/waterSupply.3f3a5e4b65385219c157caa2a3528354.svg";
export { ForwardRef as ReactComponent };